<template>
   <div :class="{hasError:isError}" style="width: 100%;"> 
    <div class="textbox" style="width: 100%;">
        <label>Vendor Code </label>
        <div>
            <InputText 
            :maxlength="maxlength"
            :placeholder="placeholder" 
            v-model="VendorCode"
             @change="PassVendorCode()" 
            :disabled="disabled" />
            <Button label="Check" severity="info" @click="CheckVendorCode(true)" :disabled="disabled" />
        </div>
    </div>
    <Dialog v-model:visible="showDialog" modal header="Vendor Code" :style="{ width: '60vw' }">
        <div>
            <DataTable 
            :value="sapVendorcode" 
            dataKey="LIFNR" 
            tableStyle="min-width: 40rem" >
               

                <Column field="IsSelect" header="IsSelect">
                    <template #header>
                        <Checkbox v-model="IsSelectAll" :binary="true"  />          
                    </template>
                   <template #body="slotProps">
                       <Checkbox v-model="slotProps.data.IsSelect" :binary="true" :disabled="!MaterialGroup && (slotProps.data.IsUsed==true || slotProps.data.IsApplied==true)" />          
                   </template>
                 </Column>

                <Column field="LIFNR" header="Vendor Code"></Column>
                <Column field="NAME" header="Vendor Name"></Column>
                <Column header="in use">
                    <template #body="slotProps">
                        <i class="pi pi-check" v-if="slotProps.data.IsUsed==true"></i>
                    </template>
                </Column>
                <Column header="in apply">
                    <template #body="slotProps">
                        <i class="pi pi-check" v-if="slotProps.data.IsApplied==true"></i>
                    </template>
                </Column>
                
              
            </DataTable>
            <br />
            <Button label="確定" @click="Confirm"></Button>
        </div>
    </Dialog>
    
        <DataTable :value="selectedVendorcode" dataKey="VendorCode" 
            paginator :rows="5"
            :rowsPerPageOptions="[5, 10, 20, 50]">
            <Column :exportable="false" bodyStyle="padding: 0rem 1rem;" headerStyle="max-width:2rem;padding: 0.5rem 1rem;"
                header="Delete">
                <template #body="slotProps">
                    <Button icon="pi pi-trash" severity="danger" text
                        @click="DeleteVendorCode(slotProps.data.VendorCode)" style="width: 50%;padding: 0.3rem;" />
                </template>
            </Column>
            <Column field="VendorCode" header="Vendor Code" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
            <Column field="VendorName" header="Vendor Name" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
            
        </DataTable>
    </div>



</template>  
<script>

import Service from "../../service/service";
import SapService from "../../service/SapService";

export default {
    props: ["modelValue", 'display_chk', 'MaterialGroup', 'disabled', 'ApplyID','maxlength'],
    emits: ["update:modelValue"],
    
    data() {
        return {
            IsSelectAll:false,
            VendorCode: "",
            sapVendorcode: [],
            selectedVendorcode: [],
            selectedAll: "",
            showDialog: false,
            placeholder: "請輸入後4碼"
        }
    },
    Service: null,
    SapService: null,
    created() {
        this.Service = new Service();
        this.SapService = new SapService();
        if (this.maxlength == 5) {
            this.placeholder = "請輸入完整5碼"
        }
        this.selectedVendorcode=this.modelValue;
    },
    methods: {
        PassVendorCode() {
            for (let index = 0; index < this.selectedVendorcode.length; index++) {
                if (this.selectedVendorcode[index].disable)
                    this.selectedVendorcode.slice(index)
            }
            this.$emit('update:VendorCode_outside', this.selectedVendorcode);
        },
        async CheckVendorCode(open) {
            let self=this;
            this.VendorCode_lst = [];
             
            if(!this.VendorCode || this.VendorCode==''){
                alert('VendorCode not keyin!');
                return;
            }
            if( this.maxlength != this.VendorCode.length){
                alert('VendorCode length is wrong!');
                return;
            }
           

            let VendorCode_arr = this.VendorCode.split(';')
            //let lstVendor = ""

            if (this.VendorCode.length > 0 && VendorCode_arr.length > 0) {

               // for (let i = 0; i < VendorCode_arr.length; i++) {
               //     const x = VendorCode_arr[i];
               //     if (i != VendorCode_arr.length - 1)
               //         lstVendor += 'lstVendor=' + x + '&'
               //     else
               //         lstVendor += 'lstVendor=' + x
               // }

              
                    await this.SapService.GetSAPVendorCode(VendorCode_arr).then((data) => {
                        self.sapVendorcode = data
                    })
                
            }

            if (this.sapVendorcode.length == 0) {
                this.showDialog = false
                this.$toast.add({
                    severity: 'warn', summary: 'Warn Message', detail: '查無資料', life: 3000
                })
            }
            else {
                this.showDialog = open
            }
        },
        AllVendorCode() {
            if (this.selectedAll.length > 0) {
                this.selectedVendorcode = []
                this.VendorCode_lst.forEach(x => {
                    if (!x.disable)
                        this.selectedVendorcode.push(x)
                })
            } else {
                this.selectedVendorcode = []
            }
            this.PassVendorCode()
        },
        DeleteVendorCode(VendorCode) {

            const index = this.selectedVendorcode.findIndex((element) => {
                return element.VendorCode == VendorCode
            });
            if(index!=-1){
                this.selectedVendorcode.splice(index, 1);
            }
           

 
            if (this.selectedVendorcode.length > 0)
                this.displayTable = ''
            else
                this.displayTable = "none"
        },
        Confirm() {
            let self=this;
            this.showDialog = false;

            this.sapVendorcode.filter(x=>x.IsSelect==true).forEach(x=>{
                let find= self.selectedVendorcode.find(y=>y.VendorCode==x.LIFNR);
                if(find==undefined){
                    let o={
                        IsSelect:true,
                        VendorCode:x.LIFNR,
                        VendorName:x.NAME,
                        BG:x.BG,
                    } 
                    self.selectedVendorcode.push(o);
                   
                }
            })
        }

    },
    watch: {
       
        selectedVendorcode: function (newVal, oldVal) {
              // watch it
              console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", this.selectedVendorcode );
            },
            IsSelectAll: function ( ) {
            this.sapVendorcode.forEach(x=>{

                if(!(!this.MaterialGroup && (x.IsUsed==true || x.IsApplied==true))){
                    x.IsSelect = this.IsSelectAll;
                }

            })
        }
   },
    computed: {
        isError() {
            return   !this.disabled &&  this.selectedVendorcode.length==0    ;
    },
    isLoading() {
      return this.$store.state.isLoading;
      //return false;
    },
    user() {
     return this.$store.state.user;
    },
    user_userName() {
     return this.$store.state.user?.userName;
    },
    user_buyerMapping() {
     return this.$store.state.user?.buyerMapping;
    },
    user_sourcerMapping() {
     return this.$store.state.user?.sourcerMapping;
    },
    user_vendorMapping() {
     return this.$store.state.user?.vendorMapping;
    },
    user_mfgcode() {
     return this.$store.state.user?.mfgcode;
    },
    user_mfgsearchterm() {
     return this.$store.state.user?.mfgsearchterm;
    },
    user_roles() {
     return this.$store.state.user?.Roles;
    },
    clientId() {
     return this.$store.state.user?.clientId;
    },


    is_VIPAdmin(){
       return this.user_roles && this.user_roles.includes('VIPAdmin');
    },
    is_SCSI(){
       return this.user_roles && this.user_roles.includes('SCSI');
    },
    is_Sourcer(){
       return this.user_roles && this.user_roles.includes('Sourcer');
    },
    is_Buyer(){
       return this.user_roles && this.user_roles.includes('Buyer');
    },
    is_CompalUser(){
       return this.user_roles && this.user_roles.includes('CompalUser');
    },
    is_VendorUser(){
       return this.user_roles && this.user_roles.includes('VendorUser');
    },
    is_Supervisor(){
       return this.user_roles && this.user_roles.includes('Supervisor');
    },
    token() {
     return this.$store.state.token;
    },
    refreshToken() {
     return this.$store.state.refreshToken;
    },
    sessionCode() {
     return this.$store.state.sessionCode;
    },


     

  },
}
</script>
  

<style scoped>
.hasError label {
  color:red;
  border-color: red;
  border-width: thin;
}
.hasError {
  color:red;
  border-color: red;
  border-width: thin;
  border: 1px solid;
  border-radius: 5px;
}
</style>